import { useCallback, useMemo } from 'react';
import { Location } from 'react-router-dom';

import { useReset } from 'pages/audience/shared';
import { buildUrl } from 'utilities/strings';

export const useResetAudienceStore = () => {
  const reset = useReset();

  const path = useMemo(() => buildUrl('Root.children.AudienceBuilder.path'), []);

  return useCallback(
    (current: Location, previous?: Location) => {
      const pathname = current.pathname.toLowerCase();
      const previousPathName = previous?.pathname.toLowerCase();

      if (previousPathName?.includes(path) && !pathname.includes(path)) {
        reset();
      }
    },
    [path, reset]
  );
};
